export default "__VITE_ASSET__CDVBQh4S__"